import { useMutation } from '@tanstack/react-query';

import { Http } from '@/services/httpRequest';

import type { SetUserClientAccessResult, SetUserClientAccessVariables } from './types';

/** Manual hook — not generated. Http.putRequest defaults to application/json-patch+json, which fails class-validator on the backend. */
export const useSetUserClientAccess = () => {
    return useMutation<SetUserClientAccessResult, Error, SetUserClientAccessVariables>({
        mutationFn: async ({ userId, clientId, locationIds, fullClientAccess }) => {
            const response = await Http.putRequest(
                `/api/v2/user/${userId}/client-access`,
                undefined,
                { clientId, locationIds, fullClientAccess },
                undefined,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                }
            );
            return response.data as SetUserClientAccessResult;
        },
    });
};
